/**
 * 组件名称
 */

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNumber } from 'react-hanger';

import { room } from '@/modules/widgets/lib';
import { UiToast } from '@/components';
import { request, hooks } from '@/lib';
import RoomBase from './room-base';

const StageAcceptFight = (props) => {
  const { item } = props;

  const seconds = useNumber(item.surplus || 10);
  const isAutoReject = seconds.value === 0;

  hooks.useInterval(
    () => {
      seconds.decrease();
    },
    !isAutoReject ? 1000 : undefined,
  );

  useEffect(() => {
    if (isAutoReject) {
      handleAccept(false);
      props.onClose();
    }
  }, [isAutoReject]);

  const handleAccept = (isOk: boolean) => {
    request.funny
      .post('api/v1/multiRoom/war/handleInvite', {
        roomId: room.getRoomId(),
        warId: item.warId,
        handleType: isOk ? 1 : 0,
      })
      .then(() => {
        UiToast.text(`已${isOk ? '接受' : '拒绝'}厅战邀请`);
        props.onClose();
      })
      .catch((err) => {
        UiToast.fail(err.msg || '操作失败');
      });
  };

  return (
    <Wrap>
      <RoomBase item={item} />
      <p className="pk-duration">PK时长: {item.minute}分钟</p>
      <ul className="actions">
        <button
          className="btn btn-outline reject-btn"
          onClick={() => handleAccept(false)}
        >
          拒绝 {seconds.value}s
        </button>
        <button className="btn ok-btn" onClick={() => handleAccept(true)}>
          接受
        </button>
      </ul>
    </Wrap>
  );
};

const Wrap = styled.ul`
  padding-top: 26px;
  .actions {
    padding: 0 16px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn {
    width: 160px;
    height: 44px;
    border-radius: 44px;
    border: 1px solid #8955f7;
    color: #8955f7;
    &:first-child {
      margin-right: 25px;
    }
  }
  .pk-duration {
    padding: 14px 0 24px;
    color: #fff;
    text-align: center;
  }
  .ok-btn {
    background: linear-gradient(270deg, #c669ff 0%, #7555f7 100%);
    color: #fff;
    border: 0;
  }
`;

export default StageAcceptFight;
